export const CHANGE_MENU_STATE = 'application/CHANGE_MENU_STATE';
export const CHANGE_UPLOADFORM_STATE = 'application/CHANGE_UPLOADFORM_STATE';
export const CHANGE_SETTINGSMENU_STATE = 'application/CHANGE_SETTINGSMENU_STATE';
export const CHANGE_SUBSETTINGSMENU_STATE = 'application/CHANGE_SUBSETTINGSMENU_STATE';
export const CHANGE_SUBUPLOADMENU_STATE = 'application/CHANGE_SUBUPLOADMENU_STATE';
export const CHANGE_HISTORYMENU_STATE = 'application/CHANGE_HISTORYMENU_STATE';
export const CHANGE_CONTACTFORM_STATE = 'application/CHANGE_CONTACTFORM_STATE';
export const CHANGE_BACKARROW_STATE = 'application/CHANGE_BACKARROW_STATE';

export const applicationInitialState = {
  menuActive: false,
  uploadFormActive: false,
  settingsMenuActive: false,
  historyMenuActive: false,
  contactFormActive: false,
  backArrowActive: false,
};

export const changeMenuAction = payload => ({type: CHANGE_MENU_STATE, payload});
export const changeUploadFormAction = payload => ({type: CHANGE_UPLOADFORM_STATE, payload});
export const changeSettingsMenuAction = payload => ({type: CHANGE_SETTINGSMENU_STATE, payload});
export const changeSubSettingsMenuAction = payload =>({type: CHANGE_SUBSETTINGSMENU_STATE, payload});
export const changeSubUploadMenuAction = payload =>({type: CHANGE_SUBUPLOADMENU_STATE, payload});
export const changeHistoryMenuAction = payload =>({type: CHANGE_HISTORYMENU_STATE, payload});
export const changeContactFormAction = payload =>({type: CHANGE_CONTACTFORM_STATE, payload});
export const changeBackArrowAction = payload => ({type: CHANGE_BACKARROW_STATE, payload});

export const applicationReducer = (state = applicationInitialState, action) => {
  switch (action.type) {
  case CHANGE_MENU_STATE:
    return {
      ...state,
      menuActive: action.payload,
    };
  case CHANGE_SETTINGSMENU_STATE:
    return {
      ...state,
      backArrowActive: false,
      settingsMenuActive: action.payload,
    };
  case CHANGE_UPLOADFORM_STATE:
    return {
      ...state,
      backArrowActive: false,
      uploadFormActive: action.payload,
    };
  case CHANGE_HISTORYMENU_STATE:
    return {
      ...state,
      backArrowActive: !state.backArrowActive,
      historyMenuActive: action.payload,
      menuActive: false,
    };
  case CHANGE_CONTACTFORM_STATE:
    return {
      ...state,
      backArrowActive: false,
      contactFormActive: action.payload,
      menuActive: false,
    };
  case CHANGE_SUBSETTINGSMENU_STATE:
    return {
      ...state,
      menuActive: !state.menuActive,
      backArrowActive: !state.backArrowActive,
      settingsMenuActive: action.payload,
    };
  case CHANGE_SUBUPLOADMENU_STATE:
    return {
      ...state,
      menuActive: !state.menuActive,
      backArrowActive: !state.backArrowActive,
      uploadFormActive: action.payload,
    };
  case CHANGE_BACKARROW_STATE:
    return {
      ...state,
      backArrowActive: action.payload,
      menuActive: !state.menuActive,
      settingsMenuActive: false,
      uploadFormActive: false,
      historyMenuActive: false,
    };
  default:
    return state;
  }
};

export const selectMenuActive = state => state.application.menuActive;
export const selectSettingsMenuState = state => state.application.settingsMenuActive;
export const selectUploadFormActive = state => state.application.uploadFormActive;
export const selectHistoryMenuActive = state => state.application.historyMenuActive;
export const selectContactFormActive = state => state.application.contactFormActive;
export const selectBackArrowState = state => state.application.backArrowActive;
